import { Checkbox, Alert } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

export interface LegalInformationProps {
  hasLegalDetails: boolean;
  showLegal: boolean;
  onShowLegalChange: () => void;
}

export const LegalInformation = ({
  hasLegalDetails,
  showLegal,
  onShowLegalChange,
}: LegalInformationProps): JSX.Element => {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.questions.legal' });
  return (
    <>
      <Checkbox
        id="show_legal"
        name="show_legal"
        isDisabled={!hasLegalDetails && !showLegal}
        isChecked={showLegal}
        onChange={onShowLegalChange}
        isInvalid={showLegal && !hasLegalDetails}
        labelContent={t('label')}
      />

      {!showLegal && !hasLegalDetails && (
        <Alert kind="info" title={t('alert-title')}>
          {t('configure-site-settings')}
        </Alert>
      )}

      {showLegal && !hasLegalDetails && (
        <Alert kind="danger">{t('configure-site-settings-or-untick')}</Alert>
      )}
    </>
  );
};
